import * as React from "react";

/** 마지막 스크롤 이후 이 시간이 지나면 "스크롤 중"을 해제한다 */
const IDLE_DELAY_MS = 700;

/**
 * 스크롤 컨테이너가 지금 스크롤 중인지 알려준다.
 * 오버레이 스크롤바를 "hover 또는 스크롤 중"에만 노출하기 위한 것으로,
 * hover 는 CSS 로 되지만 스크롤 여부는 JS 로만 알 수 있다.
 */
export function useScrollActivity(idleDelayMs: number = IDLE_DELAY_MS) {
  const [isScrolling, setIsScrolling] = React.useState(false);
  const idleTimerRef = React.useRef<number | null>(null);

  React.useEffect(
    () => () => {
      if (idleTimerRef.current) clearTimeout(idleTimerRef.current);
    },
    [],
  );

  const onScroll = () => {
    setIsScrolling(true);
    if (idleTimerRef.current) clearTimeout(idleTimerRef.current);
    idleTimerRef.current = window.setTimeout(
      () => setIsScrolling(false),
      idleDelayMs,
    );
  };

  return { isScrolling, onScroll };
}
